export default __webpack_public_path__ + "static/media/invalid.3060cbec.svg";